export default __webpack_public_path__ + "static/media/ADV.2e7e3ee2.jpg";